import React, { useSyncExternalStore } from 'react';
import Button from './Button';
import pushNotifications from '../../services/pushNotifications';

export default function PushNotificationControl() {
  const { enabled, busy, available, message } = useSyncExternalStore(
    pushNotifications.subscribe, pushNotifications.getSnapshot, pushNotifications.getSnapshot,
  );
  return (
    <div className="mt-3 space-y-2">
      <p className="text-xs text-muted-foreground font-caption">
        {enabled ? 'Device notifications are on for this account.'
          : 'Get device notifications even when app is closed.'}
      </p>
      <Button
        type="button" variant="outline" size="sm" fullWidth
        iconName={enabled ? 'BellOff' : 'BellRing'} loading={busy}
        disabled={!enabled && !available}
        onClick={() => { void (enabled ? pushNotifications.disable() : pushNotifications.enable()); }}
      >
        {enabled ? 'Turn off device notifications' : 'Enable device notifications'}
      </Button>
      {message && <p role="status" className="text-xs text-muted-foreground font-caption">{message}</p>}
    </div>
  );
}
